<template>
  <span>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn text :class="classButton" :color="color" fab dark x-small v-on="on" outlined>
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ subtitle }}</span>
    </v-tooltip>
  </span>
</template>
<script>
export default {
  props: ["color", "icon", "subtitle", "classButton"],
};
</script>
